// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bFR6eCdcf2a2G1 {
  display: flex;
  visibility: hidden;
  position: absolute;
  z-index: 40;
  top: 2px;
  right: 2px;
  box-sizing: content-box;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 4px;
  border-radius: 3px;
  opacity: 0.8;
  background-clip: padding-box;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  background-origin: padding-box;
}
.bFR6eCdcf2a2G1:hover {
  opacity: 1;
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
.bFR6eCdcf2a2G1:active {
  opacity: 1;
  background-color: var(--ds-background-accent-gray-subtle, #8590a2);
}
.bFR6eCdcf2a2G1.A4pjPdipfztplq {
  visibility: visible;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editCardButton": `bFR6eCdcf2a2G1`,
	"show": `A4pjPdipfztplq`
};
export default ___CSS_LOADER_EXPORT___;
